import React from "react";
import {PriceType} from "state/types";
import MedicationPriceElement from "./medication-price-element";

export interface MedicationPriceCardProps {
    perPillPrimePrice?: PriceType,
    totalPrimePrice?: PriceType,
    totalRetailPrice?: PriceType,
}

const MedicationPriceCardV2 = ({perPillPrimePrice, totalPrimePrice, totalRetailPrice}: MedicationPriceCardProps) => {
    return (
        <>
            <pui-section flowDirection="horizontal" mainAxisArrangement="space-between" fullWidth>
                {!!perPillPrimePrice &&
                    <pui-card class="price-card-v2" spacingleft="med-small" spacingright="mini" fullWidth noshadow="true" noBorder>
                        <pui-text input="Per tablet" textColor="grey" textSize="medium-font" textalign="center"></pui-text>
                        <MedicationPriceElement price={perPillPrimePrice}/>
                        <pui-icon imgClass="a-icon a-icon-prime a-icon-small"></pui-icon>
                    </pui-card>
                }
                {!!totalPrimePrice &&
                    <pui-card class="price-card-v2" spacingright="med-small" spacingleft="mini" fullWidth noshadow="true" noBorder>
                        <pui-text input="Total" textColor="grey" textSize="medium-font" textalign="center"></pui-text>
                        <MedicationPriceElement price={totalPrimePrice}/>
                        <pui-icon imgClass="a-icon a-icon-prime a-icon-small"></pui-icon>
                    </pui-card>
                }
            </pui-section>
            <pui-section flowDirection="horizontal" mainAxisArrangement="center" spacingtop="small" spacingbottom="medium" fullWidth>
                <pui-text input="Compare to total retail price: " textSize="medium-font" textColor="grey"></pui-text>
                <pui-text input={`\$${totalRetailPrice?.amount.toFixed(2)}`} textSize="medium-font" textColor="grey" spacingLeft="mini"
                          textDecorationLine="line-through">
                </pui-text>
            </pui-section>
        </>
    )
}

export default MedicationPriceCardV2;
